import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
} from './dossier-attachment.action';
import { DossierAttachment } from './dossier-attachment.model';

export interface DossierAttachmentRecordsState {
    listData: any[];
    singleData: DossierAttachment;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: DossierAttachmentRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
};


export const dossierAttachmentRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData: listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(resetState, () => initialState)  // Reset action handler
);